<div class="wrapper">
    <ng4-loading-spinner></ng4-loading-spinner>

    <app-header></app-header>


    <router-outlet></router-outlet>


    <!-- <app-footer></app-footer> -->

</div>
<!--/wrapper-->


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/app.component.html